/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function () {
  const variantEl = document.querySelector('input[name="id"], select[name="id"]');
  const klTrigger = document.querySelector('.klaviyo-bis-trigger');

  if (!variantEl || !klTrigger) return;

  let lastVariantId = variantEl.value;

  function resetKlaviyo() {
    // Force destroy old state
    if (window._klOnsite) {
      window._klOnsite.push(['unsubscribe']);
      window._klOnsite.push(['reset']);
    }

    // Trigger refresh on the current variant
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['refresh']);

    console.log('[Klaviyo] Reset and refreshed for variant ID: ' + variantEl.value);
  }

  function watchVariantChange() {
    const newId = variantEl.value;
    if (newId !== lastVariantId) {
      lastVariantId = newId;
      resetKlaviyo();
    }
  }

  // Delay initial trigger to ensure variant has settled
  setTimeout(() => {
    resetKlaviyo();
  }, 300);

  // Observe input or select value change (covers theme-driven updates)
  const observer = new MutationObserver(watchVariantChange);
  observer.observe(variantEl, { attributes: true, attributeFilter: ['value'] });

  // Fallback for manual change events
  variantEl.addEventListener('change', resetKlaviyo);
});

document.addEventListener('DOMContentLoaded', function () {
  var productRoot = document.querySelector('[data-product]');
  if (!productRoot) return;

  var productJsonEl = productRoot.querySelector('[data-product-json]');
  if (!productJsonEl) return;

  var productData;
  try {
    productData = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  var url = new URL(window.location.href);
  var variantParam = url.searchParams.get('variant');
  if (!variantParam) return;

  var variants = productData.variants || [];
  if (!variants.length) return;

  var currentVariant = variants.find(function (variant) {
    return String(variant.id) === String(variantParam);
  });

  if (!currentVariant) return;
  if (currentVariant.available) return;

  var optionWrappers = Array.prototype.slice.call(
    productRoot.querySelectorAll('[data-option-position]')
  );

  if (!optionWrappers.length) return;

  function getOptionName(wrapper) {
    var label = wrapper.querySelector('.radio__legend__option-name');
    return label ? label.textContent.trim().toLowerCase() : '';
  }

  var colorNames = ['color', 'colour', 'farbe', 'couleur', 'colore', 'cor'];
  var colorIndex = -1;

  optionWrappers.forEach(function (wrapper, index) {
    if (colorNames.indexOf(getOptionName(wrapper)) !== -1) {
      colorIndex = index;
    }
  });

  if (colorIndex === -1) return;

  var selectedColor = currentVariant.options[colorIndex];
  if (!selectedColor) return;

  var firstAvailableSameColor = variants.find(function (variant) {
    return variant.options[colorIndex] === selectedColor && variant.available;
  });

  if (!firstAvailableSameColor) return;
  if (String(firstAvailableSameColor.id) === String(currentVariant.id)) return;

  url.searchParams.set('variant', firstAvailableSameColor.id);

  if (url.toString() !== window.location.href) {
    window.location.replace(url.toString());
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var lastQuickAddRequestedVariantId = null;

  function getClosestProductCard(element) {
    return element ? element.closest('[data-grid-item]') : null;
  }

  function getVariantIdFromUrl(urlString) {
    if (!urlString) return null;

    try {
      var url = new URL(urlString, window.location.origin);
      return url.searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  function getActiveCardVariantId(card) {
    if (!card) return null;

    var swatchCurrent = card.querySelector('.sibling__link--current');
    if (swatchCurrent) {
      var currentWrap = swatchCurrent.closest('[data-sibling-link]');
      if (currentWrap) {
        return getVariantIdFromUrl(currentWrap.getAttribute('data-sibling-link'));
      }
    }

    var activeSwatch = card.querySelector('[data-swatch-link][aria-current="true"]');
    if (activeSwatch) {
      return getVariantIdFromUrl(activeSwatch.getAttribute('href'));
    }

    var productLink = card.querySelector('[data-product-link]');
    if (productLink) {
      return getVariantIdFromUrl(productLink.getAttribute('href'));
    }

    return null;
  }

  document.addEventListener('click', function (event) {
    var quickAddBtn = event.target.closest('[data-quick-add-btn]');
    if (!quickAddBtn) return;

    var card = getClosestProductCard(quickAddBtn);
    lastQuickAddRequestedVariantId = getActiveCardVariantId(card);
  });

  function getOptionWrappers(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-option-position]'));
  }

  function getOptionName(wrapper) {
    var label = wrapper.querySelector('.radio__legend__option-name');
    return label ? label.textContent.trim().toLowerCase() : '';
  }

  function setRadioValue(wrapper, value) {
    var radios = wrapper.querySelectorAll('input[type="radio"][name^="options"]');

    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function setHiddenValue(wrapper, value) {
    var hidden = wrapper.querySelector('input[type="hidden"][name^="options"]');
    if (!hidden) return false;

    hidden.value = value;
    hidden.dispatchEvent(new Event('change', { bubbles: true }));

    var toggleText = wrapper.querySelector('[data-popout-toggle-text]');
    if (toggleText) toggleText.textContent = value;

    var options = wrapper.querySelectorAll('[data-popout-option]');
    options.forEach(function (option) {
      var item = option.closest('.select-popout__item');
      if (option.getAttribute('data-value') === value) {
        option.setAttribute('aria-current', 'true');
        if (item) item.classList.add('is-active');
      } else {
        option.removeAttribute('aria-current');
        if (item) item.classList.remove('is-active');
      }
    });

    return true;
  }

  function setOptionValue(wrapper, value) {
    return setRadioValue(wrapper, value) || setHiddenValue(wrapper, value);
  }

  function syncQuickAddModalToFirstAvailableSize() {
    var openModal = document.querySelector('[data-quick-add-modal][open]');
    if (!openModal) return;

    var productJsonEl = openModal.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var productData;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    var variants = productData.variants || [];
    if (!variants.length) return;

    var sourceVariant = null;

    if (lastQuickAddRequestedVariantId) {
      sourceVariant = variants.find(function (variant) {
        return String(variant.id) === String(lastQuickAddRequestedVariantId);
      });
    }

    if (!sourceVariant) return;

    var wrappers = getOptionWrappers(openModal);
    if (!wrappers.length) return;

    var colorNames = ['color', 'colour', 'farbe', 'couleur', 'colore', 'cor'];
    var colorIndex = -1;

    wrappers.forEach(function (wrapper, index) {
      var optionName = getOptionName(wrapper);
      if (colorNames.indexOf(optionName) !== -1) {
        colorIndex = index;
      }
    });

    if (colorIndex === -1) return;

    var selectedColor = sourceVariant.options[colorIndex];
    if (!selectedColor) return;

    var firstAvailableSameColor = variants.find(function (variant) {
      return variant.options[colorIndex] === selectedColor && variant.available;
    });

    var targetVariant = firstAvailableSameColor || sourceVariant;
    if (!targetVariant) return;

    wrappers.forEach(function (wrapper, index) {
      var optionValue = targetVariant.options[index];
      if (typeof optionValue !== 'undefined') {
        setOptionValue(wrapper, optionValue);
      }
    });

    var idInputs = openModal.querySelectorAll('input[name="id"]');
    idInputs.forEach(function (input) {
      input.value = targetVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    openModal.dispatchEvent(
      new CustomEvent('theme:variant:change', {
        detail: { variant: targetVariant },
        bubbles: true
      })
    );
  }

  document.addEventListener('theme:quick-add:open', function () {
    setTimeout(syncQuickAddModalToFirstAvailableSize, 120);
    setTimeout(syncQuickAddModalToFirstAvailableSize, 300);
    setTimeout(syncQuickAddModalToFirstAvailableSize, 600);
  });
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
